var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInternetGlobe = function SvgInternetGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5 26C6.604 26 1 20.396 1 13.5S6.604 1 13.5 1 26 6.604 26 13.5 20.396 26 13.5 26m0-23.959C7.187 2.041 2.04 7.187 2.04 13.5S7.187 24.958 13.5 24.958 24.958 19.812 24.958 13.5 19.812 2.04 13.5 2.04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.5 26.2C6.494 26.2.8 20.506.8 13.5S6.494.8 13.5.8s12.7 5.694 12.7 12.7-5.694 12.7-12.7 12.7m0-23.959C7.298 2.241 2.24 7.298 2.24 13.5S7.298 24.758 13.5 24.758 24.758 19.702 24.758 13.5 19.702 2.24 13.5 2.24M1 13.5C1 20.396 6.604 26 13.5 26S26 20.396 26 13.5 20.396 1 13.5 1 1 6.604 1 13.5m1.041 0C2.041 7.187 7.187 2.04 13.5 2.04S24.958 7.187 24.958 13.5 19.812 24.958 13.5 24.958 2.04 19.812 2.04 13.5",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5 26c-4.021 0-7.167-5.5-7.167-12.5S9.48 1 13.5 1c4.02 0 7.167 5.5 7.167 12.5S17.52 26 13.5 26m0-23.959c-3.375 0-6.146 5.146-6.146 11.459s2.75 11.458 6.146 11.458 6.146-5.146 6.146-11.458S16.875 2.04 13.5 2.04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.235 22.474c-1.31-2.286-2.102-5.447-2.102-8.974s.792-6.688 2.102-8.975C9.543 2.243 11.39.8 13.5.8s3.957 1.443 5.265 3.725c1.31 2.287 2.102 5.447 2.102 8.975s-.793 6.688-2.102 8.974C17.457 24.756 15.61 26.2 13.5 26.2s-3.957-1.444-5.265-3.726M9.338 5.498C8.24 7.54 7.554 10.37 7.554 13.5s.682 5.96 1.776 8.002c1.098 2.05 2.581 3.256 4.17 3.256s3.072-1.207 4.17-3.256c1.094-2.041 1.776-4.872 1.776-8.002s-.687-5.96-1.784-8.002c-1.1-2.05-2.584-3.257-4.162-3.257s-3.062 1.207-4.162 3.257M6.333 13.5c0 7 3.146 12.5 7.167 12.5 4.02 0 7.167-5.5 7.167-12.5S17.52 1 13.5 1 6.333 6.5 6.333 13.5m1.021 0c0-6.313 2.77-11.459 6.146-11.459s6.146 5.146 6.146 11.459-2.75 11.458-6.146 11.458S7.354 19.812 7.354 13.5",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.541 6.333h19.917v1.041H3.541zm0 13.312h19.917v1.042H3.541zm-2.02-6.666h23.958v1.041H1.521z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.341 6.133h20.317v1.441H3.341zm0 13.312h20.317v1.442H3.341zm-2.02-6.666h24.358v1.441H1.321zm2.22-6.446v1.041h19.917V6.333zm0 13.312v1.042h19.917v-1.042zm-2.02-6.666v1.041h23.958V12.98z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.98 1.52h1.042V25.48H12.98z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.78 1.32h1.442V25.68H12.78zm.2.2V25.48h1.042V1.52z",
    clipRule: "evenodd"
  })));
};
export default SvgInternetGlobe;